import React, { useState, useEffect, useReducer, useRef, forwardRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import CheckBox from '../../../UI/CheckBox';
import SelectBtnsStyle from '../../../UI/Selects/SelectBtnsStyle';
import MyGroupList from './MyGroupList';
import { usersApi, participantsApi, getClassByNum } from '../../../../utils'
import { ParticipantTypeEnumText } from '../../../../models/ParticipantTypeEnum'
import classes from "./SelectStudents.module.css";
import { throwApiError } from '../../../lms-shared/store/error-handling-actions';
import DeleteIcon from '../../../../assests/assessments/new/delete-icon.png'
import UserProfile from '../../../lms-shared/UI/UserProfile';
import iconUser from '../../../../assests/header/icon-user.png'
import { onKeyDown } from '../../../../service';
import CopyLinkBtn from '../../../UI/Buttons/CopyLinkBtn/CopyLinkBtn';
import DynamicMessage from '../../../lms-shared/UI/Popups/DynamicMessage/DynamicMessage';
import { DynamicMessageTypeEnum } from '../../../lms-shared/models/DynamicMessageTypeEnum';

const selectStudentsReducer = (currentSelectedStudent, action) => {
    let newState = { ...currentSelectedStudent };

    switch (action.type) {
        case 'INIT_SCHOOLS':
            // return { ...state, object: { ...state.object, courseName: "Science"}};
            // default:
            //   return state;
            newState.schools = action.schools
            return newState;
        case 'ADD_CLASS_TYPES':
            newState.schools = newState.schools.map((s) => ({ ...s, recommendedClass: action.recommendedClass, fromClass: action.fromClass, toClass: action.toClass }))
            return newState

        case 'INIT_MYGROUP':
            newState.myGroup = action.myGroup
            return newState;

        case 'SELECT_SCHOOL':
            newState.schools = newState.schools.map((s) => ({ ...s, checked: s.id === action.schoolId }))
            newState.classes = action.classes
            newState.classes = newState.classes.map(c => ({ ...c, id: c.class + "_" + c.ordinal }))
            newState.moreClasses = action.moreClasses
            newState.moreClasses = newState.moreClasses.map(c => ({ ...c, id: c.class + "_" + c.ordinal, }));
            newState.students = null;
            newState.auto = action.auto;
            return newState;

        case 'SELECT_CLASS':
            newState.classes = newState.classes.map(c => ({ ...c, checked: c.id === action.classId }));
            newState.moreClasses = newState.moreClasses.map(c => ({ ...c, checked: c.id === action.classId }));
            newState.students = action.students;
            newState.auto = null;
            return newState;

        case 'SELECT_MORE_CLASS':
            newState.classes = newState.classes.map(c => ({ ...c, checked: c.id === action.classId }));
            newState.moreClasses = newState.moreClasses.map(c => ({ ...c, checked: c.id === action.classId }));
            newState.students = action.students;
            newState.auto = null;
            return newState;

        case 'ADD_STUDENT':
            newState.students = newState.students.map(s => {
                if (s.externalId === action.externalId) {
                    const newStudent = { ...s, checked: true }
                    newState.myGroup = [...newState.myGroup, newStudent]
                    return newStudent;
                }
                else
                    return s;
            })
            return newState;

        case 'REMOVE_STUDENT':
            newState.students = newState.students?.map(s => {
                if (s.externalId === action.externalId) {
                    return { ...s, checked: false };
                }
                else
                    return s;
            })
            newState.myGroup = newState.myGroup.filter(s => s.externalId !== action.externalId)
            return newState;
        default:
            throw new Error('Should not get there')
    }
};

const SelectStudents = forwardRef(({ studyGroup, studyGroupId, handleChangeStudyGroupDescription, newCourse }, ref) => {

    const { direction, texts } = useSelector(state => state.translate);
    const { courses } = useSelector(state => state.courses);
    const { homeUrl } = useSelector(state => state.application);
    const { uiData } = useSelector((state) => state.general);
    const [selectedStudent, dispatch] = useReducer(selectStudentsReducer, { schools: [], myGroup: [], classes: [] });
    const [currentSchool, setCurrentSchool] = useState({ id: null, name: "" })
    const [currentClass, setCurrentClass] = useState({ class: null, ordinal: null, allClass: false })
    const [description, setDescription] = useState({ school: null, class: null })
    const [teachers, setTeachers] = useState()
    const [msg, setMsg] = useState()

    const baseDispatch = useDispatch()
    // https://stackoverflow.com/questions/54954385/react-useeffect-causing-cant-perform-a-react-state-update-on-an-unmounted-comp
    const componentMounted = useRef(true);

    useEffect(() => {
        return () => {
            componentMounted.current = false;
        }
    }, [])

    useEffect(() => {
        async function getSchools() {
            usersApi.usersFilterSchoolsRangePost((error, resdata, response) => {
                if (error) {
                    baseDispatch(throwApiError({
                        userMessage: texts.schoolsFilterError,
                        error: error,
                        statusCode: response?.statusCode,
                        message: "usersFilterSchoolsRangePost " + error.message,
                        level: 2,
                        component: "SelectStudents",
                        line: 94
                    }));
                } else {
                    if (componentMounted.current) {
                        const filteredSchools = resdata.map(school => ({
                            ...school,
                            classes: school.classes
                                .filter(cls => cls.ordinal !== undefined)  // Exclude classes without ordinal
                                .filter((cls, index, self) =>
                                    index === self.findIndex(c => c.class === cls.class && c.ordinal === cls.ordinal)
                                ) 
                        }));
    
                        dispatch({ type: 'INIT_SCHOOLS', schools: filteredSchools });
    
                        const courseId = Array.isArray(studyGroup) ? studyGroup[0]?.courseId : studyGroup?.courseId;
                        const currentCourse = courses.find(c => c.courseId == courseId)?.course;
                        dispatch({
                            type: 'ADD_CLASS_TYPES',
                            recommendedClass: currentCourse?.recommendedClass || currentCourse?.fromClass,
                            fromClass: currentCourse?.fromClass,
                            toClass: currentCourse?.toClass
                        });
                    }
                }
            });
        }
    
        if (courses.length) {
            getSchools();
        }
    }, [courses]);

    useEffect(() => {
        async function getMyGroup() {
            const data = {
                studyGroupId,
                // participantType: ParticipantTypeEnumText.student,
                includeMOEInfo: true
            }

            let myGroup = []
            let myTeachers = []
            participantsApi.participantsFilterRangePost({ participantsRangeFilter: data }, (error, resdata, response) => {
                if (error) {
                    baseDispatch(throwApiError({ userMessage: texts.participantsFilterError, error: error, statusCode: response?.statusCode, message: "participantsFilterRangePost " + error.message, level: 2, component: "SelectStudents", line: 128 }))
                } else {
                    if (componentMounted.current) {
                        response.body.forEach(r => {
                            if (r.participantType === "Student")
                                myGroup.push({ ...r.user, checked: true })
                            else {
                                myTeachers.push({ ...r.user })
                            }
                        })
                        setTeachers(myTeachers)
                        dispatch({ type: 'INIT_MYGROUP', myGroup: myGroup });
                    }
                }
            })
        }
        if (studyGroupId) {
            getMyGroup()
        }
    }, [studyGroupId])

    useEffect(() => {
        let myGroupStudents = selectedStudent.myGroup.map(mg => { return { school: mg?.schoolId, class: `${getClassByNum(mg?.class)}'${mg?.ordinal}` } });
        let schoolIdsU = [...new Set(myGroupStudents.map(s => s.school))]
        if (schoolIdsU.length > 1) {
            setDescription({ school: texts.mixed, class: "" })
        } else {
            let classesU = [...new Set(myGroupStudents.map(s => s.class))]
            classesU.length == 0 ? setDescription({ school: "", class: "" }) :
                classesU.length > 1 ?
                    setDescription({ school: currentSchool.name, class: texts.mixed }) :
                    setDescription({ school: currentSchool.name, class: classesU[0] })
        }
        // if (setValid) {
        //     selectedStudent.myGroup.length > 0 ? setValid(true) : setValid(false)
        // }

    }, [selectedStudent.myGroup])

    // auto fetch first school;
    useEffect(() => {
        if (selectedStudent?.schools?.length && selectedStudent.schools[0].recommendedClass && !selectedStudent.schools.find(s => s.checked === true)) {
            fetchClasses(selectedStudent.schools[0].id, 1)
        }
    }, [selectedStudent.schools])

    // auto fetch first class;
    useEffect(() => {
        if (selectedStudent?.auto === 1) {
            if (selectedStudent.classes?.[0]?.id) {
                fetchStudents(selectedStudent.classes[0].id, true);
            }
            else {
                if (selectedStudent.moreClasses?.[0]?.id) {
                    fetchStudents(selectedStudent.moreClasses[0].id, false);
                }
            }
        }
    }, [selectedStudent.auto])

    useEffect(() => {
        if (newCourse) {
            description.class == "" && description.school == "" ?
                handleChangeStudyGroupDescription(`${studyGroup.subject}`) :
                description.class !== "" ?
                    handleChangeStudyGroupDescription(`${texts.school} ${description.school}, ${description.class}`) :
                    handleChangeStudyGroupDescription(`${texts.school} ${description.school} ${description.class}`)
        }
    }, [description])

    const fetchClasses = async (schoolId, auto) => {
        let classes = []
        selectedStudent.schools.map(s => s.id === schoolId && setCurrentSchool({ id: s.id, name: s.name }))
        // selectedStudent.schools.map(s => s.id === schoolId ? classes = s.classes : classes)
        selectedStudent.schools.map(s => s.id === schoolId ? s.classes.forEach(c => {
            if (c.class == s.recommendedClass || !s.recommendedClass) {
                classes.push(c)
            }
        }) : classes)
        let moreClasses = []
        selectedStudent.schools.map(s => s.id === schoolId ? s.classes.forEach(c => {
            if (c.class >= s.fromClass && c.class <= s.toClass && c.class != s.recommendedClass) {
                moreClasses.push(c)
            }
        }) : moreClasses)
        dispatch({ type: 'SELECT_SCHOOL', schoolId: schoolId, classes: classes, moreClasses: moreClasses, auto });
    }

    async function fetchStudents(classId, more) {
        let classChosen = { class: null, ordinal: null }
        selectedStudent.classes.concat(selectedStudent.moreClasses).forEach(c => {
            if (c.id === classId) {
                setCurrentClass({ class: c.class, ordinal: c.ordinal, allClass: false })
                classChosen = { class: c.class, ordinal: c.ordinal }
            }
        });
        const data = {
            schoolId: currentSchool.id,
            class: classChosen.class,
            ordinal: classChosen.ordinal
        }
        let students = []
        usersApi.usersFilterStudentsRangePost({ mOEStudentsRangeFilter: data }, (error, resdata, response) => {
            if (error) {
                baseDispatch(throwApiError({ userMessage: texts.schoolsStudentsFilterError, error: error, statusCode: response?.statusCode, message: "usersFilterStudentsRangePost " + error.message, level: 2, component: "SelectStudents", line: 212 }))
            } else {
                if (componentMounted.current) {
                    students = response.body.map(s => {
                        if (selectedStudent.myGroup.find(mg => mg.externalId === s.externalId))
                            return { ...s, checked: true }
                        return s
                    })
                    students = students.sort((a, b) => Number(a.checked || 0) - Number(b.checked || 0) || a.firstName.localeCompare(b.firstName))
                    more ? dispatch({ type: 'SELECT_MORE_CLASS', classId: classId, students: students })
                        : dispatch({ type: 'SELECT_CLASS', classId: classId, students: students })
                }
            }
        })
    }

    async function addOrRemoveStudents(post, key, data, deleteTeacher = false) {
        participantsApi[`participants${post}Post`]({ [key]: data }, (error, resdata, response) => {
            if (error) {
                baseDispatch(throwApiError({ userMessage: !deleteTeacher ? texts.participantsUpdateError : texts.participantsDeleteTeacherError, error: error, statusCode: response?.statusCode, message: "addOrRemoveStudents " + error.message, level: 2, component: "SelectStudents", line: 228 }))
            }
            else {
                if (componentMounted.current) {
                    if (deleteTeacher) {
                        let arr = [...teachers]
                        const objWithIdIndex = teachers.findIndex((obj) => obj.externalId === data.userExternalId);
                        arr.splice(objWithIdIndex, 1);
                        setTeachers(arr)
                    }
                }
            }
        })
    }

    const addStudent = (externalId) => {
        let data = { studyGroupId: studyGroupId, userExternalId: externalId, participantType: ParticipantTypeEnumText.student }
        addOrRemoveStudents("Add", "participantInput", data)
        dispatch({ type: 'ADD_STUDENT', externalId: externalId });
    }

    const removeStudent = (externalId) => {
        let data = { studyGroupId: studyGroupId, userExternalId: externalId, participantType: ParticipantTypeEnumText.student }
        addOrRemoveStudents("Delete", "participantInput", data)
        dispatch({ type: 'REMOVE_STUDENT', externalId: externalId });
    }

    const addAllClass = () => {
        let userCodeIls = selectedStudent.students.filter(s => !s.checked).map(s => s.externalId)
        let data = { studyGroupId: studyGroupId, usersExternalIds: userCodeIls }
        addOrRemoveStudents("AddRange", "participantsRangeInput", data)
        userCodeIls.map(s =>
            dispatch({ type: 'ADD_STUDENT', externalId: s })
        )
        setCurrentClass({ ...currentClass, allClass: true })
    }

    const removeAllClass = () => {
        let userCodeIls = selectedStudent.students.map(s => s.externalId)
        let data = { studyGroupId: studyGroupId, usersExternalIds: userCodeIls }
        addOrRemoveStudents("DeleteRange", "participantsRangeInput", data)
        selectedStudent.students.map(s =>
            dispatch({ type: 'REMOVE_STUDENT', externalId: s.externalId })
        )
        setCurrentClass({ ...currentClass, allClass: false })
    }

    const getSelecetedSchool = () => {
        return selectedStudent.schools.find(s => s.checked === true)
    }

    const getSelectedClass = () => {
        const selectedClass = selectedStudent.classes?.find(c => c.checked === true)
        return selectedClass ? selectedClass : selectedStudent.moreClasses?.find(c => c.checked === true);
    }

    const getStudentUrl = () => {
        let urlDirect
        if (Array.isArray(studyGroup)) {
            urlDirect = `${window.config.studentSideOriginalUrl}${homeUrl}/directConnect/${studyGroup[0]?.courseId}/${studyGroup[0]?.id}`;
        }
        else {
            urlDirect = `${window.config.studentSideOriginalUrl}${homeUrl}/directConnect/${studyGroup?.courseId}/${studyGroup?.id}`;
        }
        return urlDirect
    }

    const getTeacherUrl = () => {
        let urlDirect
        if (Array.isArray(studyGroup)) {
            urlDirect = `${window.location.origin}${uiData.baseNameTeacher}${homeUrl}/connect/${studyGroup[0]?.courseId}/${studyGroup[0]?.id}`;
        }
        else {
            urlDirect = `${window.location.origin}${uiData.baseNameTeacher}${homeUrl}/connect/${studyGroup?.courseId}/${studyGroup?.id}`;
        }
        return urlDirect
    }

    const DeleteTeacher = (p) => {
        let data = { studyGroupId: studyGroupId, userExternalId: p.externalId, participantType: ParticipantTypeEnumText.teacher }
        setMsg(<DynamicMessage type={DynamicMessageTypeEnum.Warn} cancelFunc={() => setMsg(null)} confirmFunc={() => confirmDeleteTeacher(data)} content={texts.MessageContentDeleteTeacherFromStudyGroupWarn} />)
    }

    const confirmDeleteTeacher = (data) => {
        let deleteTeacher = true
        addOrRemoveStudents("Delete", "participantInput", data, deleteTeacher)
        setMsg(null)
    }

    return (
        <div className={`${classes.SelectStudentsContainer} ${classes[direction]}`}>
            {/* <p className={classes.TitleText}>{texts.editStudents}</p> */}
            <div className={classes.SelectStudents}>
                <div className={`${classes.SchoolAndClassWrapper}`}>
                    <div className={`${classes.Overflow} ${classes.OverflowSize}`}>
                        <div className={`${classes.SchoolAndClassWrap}`}>
                            <div className={classes.Schools}>
                                <h2 className={classes.Title}>{texts.selectSchool}</h2>
                                <div className={classes.SelectSchool}>
                                    <SelectBtnsStyle value={getSelecetedSchool()?.id} setValue={(schoolId) => fetchClasses(schoolId)}>
                                        {selectedStudent.schools && selectedStudent.schools.map(s => <option key={s.id} value={s.id}>{s.name}, {s.cityName}, {s.id}</option>)}
                                    </SelectBtnsStyle>
                                </div>
                            </div>
                            <div className={classes.Classes}>
                                {/* TODO SelectClass */}
                                <h2 className={classes.Title}>{texts.selectClass}</h2>
                                {selectedStudent.classes &&
                                    <>
                                        {selectedStudent.classes.reduce((group, item) => {
                                            group[item.class] = group[item.class] ?? [];
                                            group[item.class].push(item);
                                            return group;
                                        }, []).map((current, index) =>
                                            <div className={classes.SelectClass} key={index}>
                                                <SelectBtnsStyle value={getSelectedClass()?.id} setValue={(classId) => fetchStudents(classId, false)} dropStyle={{ borderRadius: '50%', width: '36px', height: '36px' }}>
                                                    {current.map(s => <option key={s.id} value={s.id}>{getClassByNum(s.class)}'{s.ordinal}</option>)}
                                                </SelectBtnsStyle>
                                            </div>
                                        )}
                                    </>}
                                {/* TODO add more classes */}
                                {selectedStudent.moreClasses &&
                                    <>
                                        <h2 className={classes.Title}>{texts.selectMoreClass}</h2>
                                        {selectedStudent.moreClasses.reduce((group, item) => {
                                            group[item.class] = group[item.class] ?? [];
                                            group[item.class].push(item);
                                            return group;
                                        }, []).map((current, index) =>
                                            <div className={classes.SelectClass} key={index}>
                                                <SelectBtnsStyle value={getSelectedClass()?.id} setValue={(classId) => fetchStudents(classId, true)} dropStyle={{ borderRadius: '50%', width: '36px', height: '36px' }}>
                                                    {current.map(s => <option key={s.id} value={s.id}>{getClassByNum(s.class)}'{s.ordinal}</option>)}
                                                </SelectBtnsStyle>
                                            </div>
                                        )}
                                    </>}
                            </div>
                        </div>
                    </div>

                    <div>
                        {teachers &&
                            <div className={`${classes.TeacherContainer} ${classes.Overflow}`}>
                                <div className={`${classes.Teachers}`}>
                                    <h2 className={classes.Title}>{texts.designatedTeacher}</h2>
                                    {teachers.map(t =>
                                        <div className={classes.Teacher} key={t.externalId}>
                                            <UserProfile width={window.innerWidth >= 1100 ? "37px" : '25px'}
                                                image={t.profileImage ?
                                                    `${t.profileImage}` :
                                                    iconUser}
                                            />
                                            <div> {t.firstName} {t.lastName}</div>
                                            <img className={classes.DeleteIcon} src={DeleteIcon} alt="DeleteIcon" onClick={() => DeleteTeacher(t)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => DeleteTeacher(t))} />
                                        </div>)}
                                </div>
                            </div>}

                        <div className={classes.CopyTeacherLinkContainer}>
                            <CopyLinkBtn title={texts.inviteTeacherToGroupLink} url={getTeacherUrl()} width={'300px'}></CopyLinkBtn>
                        </div>
                    </div>

                </div>

                <div className={classes.Students}>
                    <h2 className={classes.Title}>{texts.selectStudents}</h2>
                    <div className={`${classes.SelectStudent} ${classes.Overflow}`}>
                        {selectedStudent.students && <div className={classes.SelectAllClass}>
                            <CheckBox
                                checked={currentClass.allClass}
                                onChecked={addAllClass}
                                onRemoveChecked={removeAllClass}
                                value={texts.selectAllClass}>
                                <div className={classes.StudentName} style={{ fontWeight: 700 }}>{texts.selectAllClass} {getClassByNum(currentClass.class)}'{currentClass.ordinal}</div>
                            </CheckBox>
                        </div>}
                        <div className={classes.SelectStudentCheckBoxs}>
                            {selectedStudent.students && selectedStudent.students.map(s =>
                                <CheckBox
                                    key={s.externalId}
                                    checked={s.checked}
                                    onChecked={(externalId) => addStudent(externalId)}
                                    onRemoveChecked={(externalId) => removeStudent(externalId)}
                                    value={s.externalId}>
                                    <div className={classes.StudentName}>{s.firstName} {s.lastName}</div>
                                </CheckBox>)}
                        </div>
                    </div>
                </div>

                <div className={classes.MyGroup}>
                    <h2 className={classes.Title}>{texts.myGroup}</h2>
                    <div className={classes.myGroupStudent}>
                        <div className={classes.Total}>{texts.total}: {selectedStudent.myGroup.length}</div>
                        {selectedStudent.myGroup !== 'undefined' && selectedStudent.myGroup.length > 0 ?
                            <div className={`${classes.MyGroupStudentListWrapper} ${classes.Overflow}`}>
                                {
                                    window.innerWidth >= 1100 ?
                                        <div className={classes.myGroupStudentList}>
                                            <MyGroupList myGroup={selectedStudent.myGroup.slice(0, Math.ceil(selectedStudent.myGroup.length / 2))} removeStudent={removeStudent} getClassByNum={getClassByNum}></MyGroupList>
                                            <MyGroupList myGroup={selectedStudent.myGroup.slice(Math.ceil(selectedStudent.myGroup.length / 2))} removeStudent={removeStudent} getClassByNum={getClassByNum}></MyGroupList>
                                        </div>
                                        :
                                        <div className={classes.myGroupStudentList}>
                                            <MyGroupList myGroup={selectedStudent.myGroup} removeStudent={removeStudent} getClassByNum={getClassByNum}></MyGroupList>
                                        </div>
                                }
                            </div> :
                            <div className={classes.NoStudents}>{texts.noStudents}</div>}
                        <div className={classes.CopyStudentLinkContainer}>
                            <div className={classes.CopyStudentLink}>
                                <CopyLinkBtn title={texts.inviteStudentToGroupLink} url={getStudentUrl()} width={window.innerWidth >= 1100 ? '300px' : '150px'}></CopyLinkBtn>
                            </div>
                        </div>
                        <div className={classes.ToRemove}>{texts.toRemoveFromMyGroup}<div className={classes.Remove}> {texts.remove}</div></div>
                    </div>
                </div>
            </div>
            {msg}
        </div>)
})

export default SelectStudents;